import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { RegistrationVerify } from 'src/app/models/registration-verify.model';
import { map } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import { DatePipe } from '@angular/common'
import { Contact } from '../models/contact.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private dbPath = 'contact';
  contactRef: AngularFirestoreCollection<Contact> = null;
  registrationVerify: RegistrationVerify;

  constructor(private firestore: AngularFirestore, private afAuth: AngularFireAuth, public datePipe: DatePipe) {
    this.contactRef = firestore.collection(this.dbPath, ref => ref.orderBy('stt', "asc"));
  }

  getContacts() {
    return this.contactRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ id: c.payload.doc.id, ...c.payload.doc.data() })
        )
      )
    );
  }

  createContact(contact: Contact) {
    return this.contactRef.add({ ...contact });
  }

  updateContact(contact: Contact) {
    return this.contactRef.doc(contact.id).update(contact);
  }

  deleteContact(contactId) {
    console.log(contactId);
    return this.contactRef.doc(contactId).delete();
  }

  deleteMultiContact(lstId) {
    for (let i = 0; i < lstId.length; i++) {
      this.contactRef.doc(lstId[i]).delete();
    }
  }
}
